import React, { useEffect, useState } from "react";
import { Quote, ChevronLeft, ChevronRight, Star } from "lucide-react";
import { testimonials } from "../mock";

const Testimonials = () => {
  const [idx, setIdx] = useState(0);
  const n = testimonials.length;

  useEffect(() => {
    const t = setInterval(() => setIdx((i) => (i + 1) % n), 6500);
    return () => clearInterval(t);
  }, [n]);

  const t = testimonials[idx];

  return (
    <section
      className="parallax py-28 relative"
      style={{
        backgroundImage:
          "linear-gradient(rgba(10,31,77,0.90), rgba(14,42,99,0.92)), url(https://images.pexels.com/photos/39192356/pexels-photo-39192356.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=1920)",
      }}
    >
      <div className="max-w-4xl mx-auto px-6 text-center text-white">
        <div className="reveal">
          <span className="eyebrow text-[#f2a25a] justify-center flex">Customer Feedback</span>
          <h2 className="font-display font-bold text-[34px] sm:text-[46px] mt-4">
            What They Say About Us
          </h2>
        </div>

        <div className="reveal reveal-delay-1 mt-12 relative">
          <Quote size={56} className="mx-auto text-[#e07c24] mb-4" />
          <p key={idx} className="hero-anim text-xl sm:text-2xl leading-relaxed text-white/90 font-light">
            <span>&ldquo;{t.text}&rdquo;</span>
          </p>
          <div className="flex justify-center gap-1 mt-8">
            {[...Array(5)].map((_, i) => (
              <Star key={i} size={20} className="text-[#f2a25a] fill-[#f2a25a]" />
            ))}
          </div>
          <p className="font-display font-bold text-2xl mt-5">{t.name}</p>
          <p className="text-white/70 text-sm">{t.role}</p>
        </div>

        <div className="flex items-center justify-center gap-4 mt-10">
          <button
            onClick={() => setIdx((i) => (i - 1 + n) % n)}
            className="w-12 h-12 rounded-full border border-white/40 flex items-center justify-center hover:bg-white hover:text-[#14357e] transition-colors"
            aria-label="Previous"
          >
            <ChevronLeft size={22} />
          </button>
          <div className="flex gap-2">
            {testimonials.map((_, i) => (
              <button
                key={i}
                onClick={() => setIdx(i)}
                className="h-2.5 rounded-full transition-all"
                style={{ width: i === idx ? "28px" : "10px", background: i === idx ? "#e07c24" : "rgba(255,255,255,0.4)" }}
                aria-label={`Testimonial ${i + 1}`}
              />
            ))}
          </div>
          <button
            onClick={() => setIdx((i) => (i + 1) % n)}
            className="w-12 h-12 rounded-full border border-white/40 flex items-center justify-center hover:bg-white hover:text-[#14357e] transition-colors"
            aria-label="Next"
          >
            <ChevronRight size={22} />
          </button>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
